import { render, staticRenderFns } from "./addNewSupplier.vue?vue&type=template&id=6027343f&scoped=true"
import script from "./addNewSupplier.vue?vue&type=script&lang=js"
export * from "./addNewSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027343f",
  null
  
)

export default component.exports